import React from 'react';
import {BrowserRouter as Router, Switch, Route} from "react-router-dom";
import Header from "./components/Header";
import Home from "./components/Home";
import 'jquery'
import 'bootstrap/dist/css/bootstrap.css';
import Footer from "./components/Footer";
import MySounds from "./components/MySounds";
import Bookmarks from "./components/Bookmarks";
import About from "./components/About";
import "./css/style.css";
import SoundPage from "./components/SoundPage";
import AdvancedSearch from "./components/AdvancedSearch";
import {setGlobal} from 'reactn';
import Explorer from "./components/Explorer";

function App() {
    global.KEY = 'mWYjV06AWLlL3YswWS377PvRPiQZmm7OxN4EbdTz';

    setGlobal({
        query: ''
    });

    return (
        <div className="container">
            <Router>
                <Header/>
                <Switch>
                    <Route exact path="/" component={Home}/>
                    <Route path="/mysounds" component={MySounds}/>
                    <Route path="/advancedsearch" component={AdvancedSearch}/>
                    <Route path="/bookmarks" component={Bookmarks}/>
                    <Route path="/explorer" component={Explorer}/>
                    <Route path="/about" component={About}/>
                    <Route path="/sound/:id" component={SoundPage}/>
                </Switch>
                <Footer/>
            </Router>
        </div>
    );
}

export default App;
